module.exports = __webpack_public_path__ + "static/media/rule.b483f4af.svg";